/**
 * Payment Gateway Service
 * Frontend service for managing payment gateways
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/**
 * List available payment gateways
 */
export const listPaymentGateways = async () => {
  const fn = httpsCallable(functions, 'listPaymentGateways');
  const result = await fn();
  return result.data;
};

/**
 * Get current gateway configuration
 */
export const getPaymentGatewayConfig = async () => {
  const fn = httpsCallable(functions, 'getPaymentGatewayConfig');
  const result = await fn();
  return result.data;
};

/**
 * Update gateway configuration
 */
export const updatePaymentGatewayConfig = async (gateway, config) => {
  const fn = httpsCallable(functions, 'updatePaymentGatewayConfig');
  const result = await fn({ gateway, config });
  return result.data;
};

/**
 * Set active payment gateway
 */
export const setActivePaymentGateway = async (gateway) => {
  const fn = httpsCallable(functions, 'setActivePaymentGateway');
  const result = await fn({ gateway });
  return result.data;
};

/**
 * Test gateway connection
 */
export const testPaymentGateway = async (gateway) => {
  const fn = httpsCallable(functions, 'testPaymentGateway');
  const result = await fn({ gateway });
  return result.data;
};

/**
 * Save gateway API keys
 */
export const saveGatewayApiKeys = async (gateway, secretKey, publicKey) => {
  const fn = httpsCallable(functions, 'saveGatewayApiKeys');
  const result = await fn({ gateway, secretKey, publicKey });
  return result.data;
};
